import { useState } from "react";

const ImageWithFallback = ({
  src,
  alt,
  fallback = "/images/placeholder.png",
  ...props
}) => {
  const [hasError, setHasError] = useState(false);
  return (
    <img
      src={hasError ? fallback : src}
      alt={alt}
      onError={() => setHasError(true)}
      {...props}
    />
  );
};

export default ImageWithFallback;
